// pages/ErrorPage.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import EmptyHeader from '../../Components/Shared/EmptyHeader';
import AuthHeader from '../../Components/Account/AuthHeader';

const UnfoundPage = ({ portalSettings }) => {
    const navigate = useNavigate();

    // If loading auth or no portal settings yet, just render nothing
    if (!portalSettings) return null;

    const psm = portalSettings || {};

    return (
        <div className="auth-page">
            <EmptyHeader/>
            <EmptyHeader/>
            <EmptyHeader/>
            <div className="auth-container">
                <AuthHeader portalSettings={portalSettings} />
                <h2 className="baseHeader">Oops!</h2>
                <p className="baseText">We couldn't find what you're looking for.</p>
                <button className="baseButton" onClick={() => navigate('/home')}>Back to Home</button>
            </div>
        </div>
    );
};

export default UnfoundPage;
